import { IFRResource } from "app/resources/ifrresource";
import { RoleResource } from "app/resources/role/role-resource";
import { CompanyResource } from "app/resources/company/company-resource";

export class UserResource extends IFRResource {

	rid: number;

	firstName: string;

	lastName: string;

	companyName: string;

	email: string;

	password: string;

	dateCreated: string;

	dateUpdated: string;

	enabled: boolean;

	role: RoleResource;

	address: string;

	email2: string;

	phone: string;

	birthDate: string;

	prefix: string;

	userPosition: string;
	
	image: string;

	imageString: string;

	position: string;

	expertise: string;

	departmentString: string;

	jobTitle: string;

	company: CompanyResource;

	gender: string;

	showDelete: boolean = false;

	logoRo: string;

	logoStringRo: string;

	logoEn: string;

	logoStringEn: string;

	logoFr: string;

	logoStringFr: string;

	logoDe: string;

	logoStringDe: string;

	bpo: boolean;

	serverSmtpEmail: string;

	serverSmtpPassword: string;

	serverSmtpPort: string;

	serverSmtpHost: string;

	isOneLogo:boolean;
	
	parrentUser: UserResource;

	showDetailsOnResponsive:boolean=false;

	canUseAppointments: boolean;
}
